<script>
  import { showQuoteForm } from '../stores/ShowQuoteForm';

  export let alternate = false;
  export let marginReset = false;

  function showQuoteModal() {
    $showQuoteForm = true;
  }
</script>

<div class="quote-button" class:margin-reset={marginReset}>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="quote-button-content" class:alternate href="#" on:click={showQuoteModal}>
    <span>Quick Quote</span>
  </div>
</div>

<style>
  .quote-button {
    margin-top: 2rem;
    margin-bottom: 2rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .quote-button.margin-reset {
    margin-top: 0;
    margin-bottom: 0;
  }

  .quote-button-content {
    font-family: 'Montserrat', sans-serif;
    font-weight: bold;
    text-transform: uppercase;
    border-radius: 1rem;
    font-size: 2rem;
    color: rgb(28, 42, 92);
    background: white;
    padding: 2rem;
  }

  .quote-button-content.alternate {
    background: rgb(28, 42, 92);
    color: white;
  }

  .quote-button-content:hover {
    background: rgb(28, 42, 92, 0.8);
    color: white;
    border: 1px solid white;
  }
</style>
